export const REQUEST_STATUS_MODAL_HEADER = 'Request Status';

export const VIEW_STATUS_ACTION_NAME = 'View Status';
export const CREATE_ACTION_NAME = 'Create';
